<template>
  <div class="row">
    <div class="col-lg-12">
      <div
        class="form-group" 
        style="min-height: 90px;"
      >
        <label class="ml-2">
          {{ $t('Sale Contact Type') }} 
          <span class="text-danger">*</span>
        </label>
        <div 
          :class="['d-flex flex-row ml-2', $parent.$parent.isStandard == 1 ? 'point-none' : '']"
        >
          <div 
            v-for="channel in channels" 
            :key="channel.id" 
            class="mr-2 text-center" 
            style="min-width: 55px;"
          >
            <input 
              v-if="$parent.$parent.isStandard == 1"
              v-model="$parent.$parent.integration.integration_type_id"
              :value="channel.id" 
              type="radio" 
              name="integration_type_id" 
              :id="'social_' + channel.id"
              class="d-none"
            >
            <input 
              v-else
              v-model="$parent.$parent.integration.integration_type_id"
              :value="channel.id" 
              type="radio" 
              name="integration_type_id" 
              :id="'social_' + channel.id"
              class="d-none"
              @click="selectChannel(channel)"
            >
            <label 
              :for="'social_' + channel.id" 
              class="mb-0"
            >
              <div class="box-img m-auto">
                <img :src="channel.logo">
              </div>
              <p class="mt-1 mb-0">{{ channel.name }}</p>
            </label>
          </div>
        </div>
        <label 
          class="validation-invalid-label" 
          for="variationInfo_channel" 
          v-if="$parent.$parent.validate_channel"
        >
          {{ $t("Please select Channel") }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/endpoint/tenant.service'

export default {
    name: "ChannelComponent",
    data() {
        return {
            channels: [],
            
        }
    },
    mounted() {
      this.feedData();
    },
    methods: {
        selectChannel(channel) {
            // this.$parent.channelName = channel.name + ' Url' 
            this.$parent.setParams(channel.name);
        },
        async feedData() {

            let queryString = "?integration_group_id=1,2,5&not_name=Salepage,Magento,WooCommerce&not_sync=yes";

            let response = await Api.Setting.getIntegrationType(queryString);
            
            if (response.data.data) {
                this.channels = response.data.data;
                this.channels = this.channels.filter((item)=> item.code != "CRM");
            }

        },
    }
}
</script>

<style scoped>

    input[type=radio]:checked + label img {
        filter: inherit;
        opacity: inherit;
    }

    input[type=radio] + label img {
        width: 100%;
        height: 100%;
        -webkit-filter: grayscale(1) brightness(100%) contrast(100%) invert(0.15);
        filter: grayscale(1) brightness(100%) contrast(100%) invert(0.15);
        opacity: 0.3;
        transition: width 0.3s, height 0.3s;
    }

    input[type=radio] + label img:hover {
        cursor: pointer;
        filter: inherit;
        opacity: inherit;
        transform: scale(1.2);
        animation: fadeIn 0.3s;
        -webkit-animation: fadeIn 0.3s;
        -moz-animation: fadeIn 0.3s;
        -o-animation: fadeIn 0.3s;
        -ms-animation: fadeIn 0.3s;
    }

    .box-img {
        position: relative;
        width: 30px;
        height: 30px;
    }
		
    @keyframes fadeIn {
        0% {opacity:0.6;}
        100% {opacity:1;}
    }

    @-moz-keyframes fadeIn {
        0% {opacity:0.6;}
        100% {opacity:1;}
    }

    @-webkit-keyframes fadeIn {
        0% {opacity:0.6;}
        100% {opacity:1;}
    }

    @-o-keyframes fadeIn {
        0% {opacity:0.6;}
        100% {opacity:1;}
    }

    @-ms-keyframes fadeIn {
        0% {opacity:0.6;}
        100% {opacity:1;}
    }

</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/settings/sale/sale-contact/Channel.vue